'use client'

import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import heroSalon from "@/assets/hero-salon.jpg";
import heroHair from "@/assets/hero-hair.jpg";
import Image from "next/image";

type Props = { onBook: () => void };

export function HeroSection({ onBook }: Props) {
  return (
    <section className="relative pt-28 md:pt-32">
      <div className="mx-auto grid max-w-[1600px] grid-cols-12 gap-4 px-6 md:px-12">
        <div className="col-span-12 md:col-span-7">
          <p className="eyebrow">Atelier · Est. 2014 · Paris / NY</p>
          <h1 className="mt-6 font-display text-[14vw] leading-[0.92] md:text-[8.2vw]">
            Your <em className="text-rose-gold">Transformation</em>,
            <br />
            Scheduled.
          </h1>
          <div className="mt-10 flex max-w-xl flex-col gap-6 md:flex-row md:items-center">
            <button onClick={onBook} className="btn-editorial group">
              Book Your Stylist
              <ArrowUpRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
            </button>
            <p className="text-sm text-muted-foreground">
              Instant confirmation. Pre-paid reservation.
              <br />Average wait: <span className="text-foreground">2 days</span>.
            </p>
          </div>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: [0.2, 0.8, 0.2, 1] }}
          className="col-span-12 md:col-span-5"
        >
          <div className="relative aspect-[4/5] overflow-hidden">
            <Image src={heroHair} alt="Premium hair treatment" width={1024} height={1280} className="h-full w-full object-cover" />
            <div className="absolute bottom-4 left-4 bg-nude/90 px-4 py-2 backdrop-blur">
              <p className="eyebrow">N° 01 — Color</p>
            </div>
          </div>
        </motion.div>
      </div>

      <div className="mx-auto mt-20 max-w-[1600px] px-6 md:px-12">
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 1 }}
          className="relative aspect-[21/9] overflow-hidden"
        >
          <Image src={heroSalon} alt="Maison Noir salon interior" width={1536} height={1024} className="h-full w-full object-cover" />
          <div className="absolute inset-0 bg-gradient-to-t from-ink/40 via-transparent to-transparent" />
          <div className="absolute bottom-8 left-8 right-8 flex items-end justify-between text-nude">
            <div>
              <p className="eyebrow !text-rose-gold-soft">The House</p>
              <p className="mt-2 max-w-md font-display text-2xl md:text-4xl">
                A sanctuary engineered for the discerning few.
              </p>
            </div>
            <p className="hidden text-[0.7rem] uppercase tracking-editorial md:block">
              14 Rue Saint-Honoré
            </p>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
